<template>
	<Modal v-model="opened" wrapper-class="modal-centered" @before-open="onBeforeOpen" @before-close="onBeforeClose">
		<template #titlebar>
			<div />
		</template>
	
		<div class="modal-title">
			{{ t.askNamePopupHeaderTitle }}
		</div>
		<div>{{ t.askNamePopupHeaderText }}</div>

		<form style="margin-top: 20px;" @submit.stop.prevent.once="setName()">
			<div class="form-group">
				<input v-model="firstName" :placeholder="t.askNamePopupNamePlaceholder" type="text" class="form-control" autocomplete="off">
			</div>
			<div class="form-group">
				<input v-model="lastName" :placeholder="t.askNamePopupSurnamePlaceholder" type="text" class="form-control" autocomplete="off">
			</div>
			<div class="form-group text-right">
				<button :class="{ 'disabled': !firstName.trim().length || !lastName.trim().length}" type="submit" class="btn-ask-name-popup">
					{{ t.genericSave }}
				</button>
			</div>
		</form>
	</Modal>
</template>

<script setup>
import { computed, inject, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { Modal } from '@kouts/vue-modal'
import bodyScrollPlugin from 'body-scroll-freezer'
import { setRouteUrlParam } from '../../routes'
import { useStore } from '@/js/stores/index';
import { useUserStore } from '@/js/stores/user';

const axios = inject('axios')
const store = useStore()
const userStore = useUserStore()
const route = useRoute()

// Reactives
const opened = ref(false)
const firstName = ref("")
const lastName = ref("")

// Computeds
const t = computed(() => store.translations)

// Watchers
watch(route, route => {
	// Check if modals should be opened/closed
	opened.value = route.query?.modal ? true : false
})

defineExpose({
	opened,
	firstName,
	lastName,
})

// Functions
async function setName(){
	var fName = firstName.value.trim()
	var lName = lastName.value.trim()

	if(!fName || !lName){
		return;
	}

	await axios.post('/api/user-side/setUserName', {
		first_name: fName,
		last_name: lName,
	})
	
	userStore.setUserFirstName(fName)
	userStore.setUserLastName(lName)

	opened.value = false
}

function onBeforeOpen() {
	setRouteUrlParam('modal', 1)
	bodyScrollPlugin.freeze()
}

function onBeforeClose() {
	setRouteUrlParam('modal', null)
	bodyScrollPlugin.unfreeze()
}
</script>
